export const BASE_PATH = window.localStorage.getItem('basePath') || (
  window.location.origin.search('localhost') !== -1 ? (window.localStorage.getItem('basePath') || 'https://nv.dev.professocial.de') : `${window.location.origin}`)

const devEnv = {
  restBase: BASE_PATH,
}

const stageEnv = {
  ...devEnv,
}

const prodEnv = {
  ...devEnv,
}

type Env = typeof devEnv
  | typeof stageEnv
  | typeof prodEnv

const getEnvValues: () => Env = () => {
  switch (process.env.BUILD_ENV) {
  case 'production':
    return prodEnv
  case 'staging':
    return stageEnv
  }
  return devEnv
}

export const isDebugEnv: boolean = process.env.BUILD_ENV !== undefined
  ? process.env.BUILD_ENV === 'development'
  : process.env.NODE_ENV === 'development'

export default getEnvValues()
